import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './NonProdBanner.module.scss';

export default function NonProdBanner() {
  return (
    <div className={styles.banner}>
      <FormattedMessage id="LOG_IN_NON_PROD_MESSAGE" />
    </div>
  );
}
